import { EmptyState } from '@backstage/core-components';
import { CatalogTableRow } from '@backstage/plugin-catalog';
import { JUPYTERHUB_TYPE, routes } from '../../lib/viva';
import { EntityArgoAppsCell } from '../catalog/cells';
import { jupyterhubColumns } from '../catalog/columns';
import { TypedCatalogPage } from '../catalog/TypedCatalogPage';
import { EntityHubServersCell } from './JupyterHubCells';

const columns = jupyterhubColumns<CatalogTableRow>(
  row => <EntityArgoAppsCell entity={row.entity} />,
  row => <EntityHubServersCell entity={row.entity} />,
);

export const JupyterHubPage = () => (
  <TypedCatalogPage
    section="jupyterhub"
    title="JupyterHub"
    subtitle="Рабочие места датасаентистов: по одному многопользовательскому JupyterHub на кластер платформы"
    kind="component"
    type={JUPYTERHUB_TYPE}
    columns={columns}
    create={{ title: 'Новый кластер', to: routes.newCluster }}
    support="JupyterHub разворачивается с каждым кластером платформы (ArgoCD, gitops platform/<кластер>/17-jupyterhub.yaml) и регистрируется в каталоге шаблоном «Новый Kubernetes-кластер». Вход — через GitLab платформы, доступ — у группы viva и команды-владельца кластера; у каждого пользователя свой под и домашний том."
    emptyContent={
      <EmptyState
        missing="data"
        title="JupyterHub пока нет"
        description="JupyterHub появляется вместе с кластером: создайте кластер из шаблона «Новый Kubernetes-кластер»."
      />
    }
  />
);
